import I18n from 'I18n';
function createAction(name) {
  return `@@submissionExport/${name}`;
}
const SHOW_EXPORT_SUCCESS_MESSAGE = createAction('SHOW_EXPORT_SUCCESS_MESSAGE');
const SHOW_EXPORT_FAILURE_MESSAGE = createAction('SHOW_EXPORT_FAILURE_MESSAGE');
export const showExportSuccessMessage = () => ({
  type: SHOW_EXPORT_SUCCESS_MESSAGE,
  meta: {
    notification: {
      type: 'success',
      title: I18n.text('submissionExport.successHeading'),
      message: I18n.text('submissionExport.successDescription')
    }
  }
});
export const showExportFailureMessage = reason => ({
  type: SHOW_EXPORT_FAILURE_MESSAGE,
  meta: {
    notification: {
      type: 'danger',
      title: I18n.text('submissionExport.failureHeading'),
      message: I18n.text(`submissionExport.failureDescriptions.${reason}`)
    }
  }
});